export default "__VITE_ASSET__IYnqMvwX__"